export enum ErrorCode {
  PageNotFound,
  ServerError,
  customError,
}
